let initialized = false;

export function initPixel(pixelId: string): void {
  if (initialized) return;
  initialized = true;

  const script = document.createElement('script');
  script.textContent = `
    !function(f,b,e,v,n,t,s){
      if(f.fbq)return;n=f.fbq=function(){
        n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)
      };
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];
      t=b.createElement(e);t.async=!0;t.src=v;
      s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)
    }(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');
  `;
  document.head.appendChild(script);

  window.fbq?.('init', pixelId);
  window.fbq?.('track', 'PageView');
}

export function trackLead(): void {
  if (initialized && typeof window.fbq === 'function') {
    window.fbq('track', 'Lead');
  }
}

export function isPixelInitialized(): boolean {
  return initialized;
}

export function resetPixel(): void {
  initialized = false;
}
